module.exports = __webpack_public_path__ + "static/looking_for_a_marketing_agency_image-262820b9960c08a79bc035d1395d78ee.svg";